/***********************************************************
V 1.0.0 - Criado por Francielle Nunes

DESCIÇÃO:
Serviço de requisições http

COMPONENTS
***********************************************************/
import { Injectable } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class HttpService {

   private _URL_api: string = 'https://api-fundacao-riobranco.oficina5.com.br';

    private _URL_REQUEST: string;

    constructor(
        private _http: Http,
    ) { }

    /************
    HEADER
    *************/
    getHeader(auth: boolean) {
        let headers = new Headers();

        //HEADER COM AUTHORIZATION
        if (auth == true) {
            headers.append('Authorization', '');
        }
        return headers
    }

    /************
    GET API
    *************/

    getApi(){
        return this._URL_api;
    }

    /************
    POST
    *************/
    JSON_POST(url, fields, auth: boolean, use_url_api: boolean): Promise<any> {
        if (use_url_api) {
            this._URL_REQUEST = this._URL_api + url
        } else {
            this._URL_REQUEST = url
        }
        return this._http.post(this._URL_REQUEST, fields, { headers: this.getHeader(auth) }).toPromise()
    }

    /************
    GET
    *************/
    JSON_GET(url, auth: boolean, use_url_api: boolean): Promise<any> {
        if (use_url_api) { this._URL_REQUEST = this._URL_api + url } else { this._URL_REQUEST = url }
        return this._http.get(this._URL_REQUEST, { headers: this.getHeader(auth) }).toPromise()
    }

    /************
    PUT
    *************/
    JSON_PUT(url, fields, auth: boolean, use_url_api: boolean): Promise<any> {
        if (use_url_api) { this._URL_REQUEST = this._URL_api + url } else { this._URL_REQUEST = url }
        return this._http.put(this._URL_REQUEST, fields, { headers: this.getHeader(auth) }).toPromise()
    }

    /************
    DELETE
    *************/
    JSON_DELETE(url, auth: boolean, use_url_api: boolean): Promise<any> {
        if (use_url_api) { this._URL_REQUEST = this._URL_api + url } else { this._URL_REQUEST = url }
        return this._http.delete(this._URL_REQUEST, { headers: this.getHeader(auth) }).toPromise()
    }

    /************
    UPLOAD
    *************/
    JSON_UPLOAD_POST(url, fields, auth: boolean, use_url_api: boolean): Promise<any> {
        if (use_url_api) { this._URL_REQUEST = this._URL_api + url } else { this._URL_REQUEST = url }
        return this._http.post(this._URL_REQUEST, fields).toPromise()
    }

    JSON_UPLOAD_PUT(url, fields, auth: boolean, use_url_api: boolean): Promise<any> {
        if (use_url_api) { this._URL_REQUEST = this._URL_api + url } else { this._URL_REQUEST = url }
        return this._http.put(this._URL_REQUEST, fields).toPromise()
    }

}



// WEBPACK FOOTER //
// ./src/app/globals/http.ts